import { atom } from "jotai";
import { type WorkspaceEntity } from "@/api/__generated__/orval/accounts";

export const workspacesAtom = atom<WorkspaceEntity[]>([]);
